module.exports = __webpack_public_path__ + "static/img/case1.1afb97d7.jpg";